import IconContainer from "@/components/ui/icon-container";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import Text from "@/components/ui/text";
import { memo } from "react";
import { getCalculateTrend } from "@/components/ui/calculate-trend";

/** A period value and the value it is compared against. */
export interface TrendValue {
  valueForPeriod: number;
  comparedToValue: number;
}

export const Trend = ({ value }: { value: TrendValue }) => {
  const calculateTrend = getCalculateTrend(value);
  return (
    <span
      className="flex flex-row ml-1 items-center"
    >
      <IconContainer
        size="sm"
        color={calculateTrend.isPositive ? "charts-positive" : "error"}
      >
        {calculateTrend.isPositive ? <ArrowUpRight /> : <ArrowDownRight />}
      </IconContainer>
      <Text
        variant="body"
        className="text-sm"
      >{`${calculateTrend.value}%`}</Text>
    </span>
  );
};

export const TrendCell = memo(
  ({
    value,
    isPercentage = false
  }: {
    value: TrendValue;
    isPercentage?: boolean;
  }) => {
    return (
      <div className="flex items-center">
        <Text variant="body">{`${Math.round(value.valueForPeriod * 10) / 10}${isPercentage ? "%" : ""}`}</Text>
        {value.comparedToValue !== 0 &&
          value.valueForPeriod !== 0 &&
          value.comparedToValue !== -1 && <Trend value={value} />}
      </div>
    );
  }
);

TrendCell.displayName = "TrendCell";
